import { Component, OnInit } from '@angular/core';
import { PhoneVerificationService } from '../services/phone-verification.service';

@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.scss']
})
export class PhoneVerificationComponent implements OnInit {
  public phoneNumberInput: string;
  public user: any;
  public returnUrl: string;
  public rememberMe: boolean;
  public remember2FA: boolean = false;
  public errorText: string;
  public submitDisabled: boolean = false;
  public phoneNumberInputReadonly: boolean = false;
  public phoneNumberHidden: boolean = false;
  public codeInput: string;
  public verifyCodeDisabled: boolean = false;
  public newCodeSent: boolean = false;
  public deliveryMethods: string[] = [];
  public deliveryMethod: string;

  public pageState: string;

  constructor(private phoneService: PhoneVerificationService) { }

  ngOnInit() {
    // Check if user info is set. If not, redirect back home
    let theWindow: any = window;
    if(!theWindow.user || theWindow.user.Id < 0) {
      window.location.href = '/';
    }

    this.user = theWindow.user;
    this.returnUrl = theWindow.returnUrl;
    this.rememberMe = theWindow.rememberMe;

    this.pageState = 'enter-number';

    // Don't allow editing of phone number if Two Factor is actually enabled
    if(this.user.TwoFactorEnabled) {
      this.phoneNumberInputReadonly = true;
      if(!this.user.TwoFactorPhoneNumber || this.user.TwoFactorPhoneNumber.length == 0) {
        this.phoneNumberHidden = true;
      }
    }

    // Set code delivery options
    if(this.phoneNumberHidden) {
      this.deliveryMethods = [
        "Email"
      ];
      this.deliveryMethod = this.deliveryMethods[0];
      this.sendCode();
    } else {
      this.deliveryMethods = [
        "Text",
        "Call"
      ];
      if(this.user.TwoFactorPhoneNumber.length > 0) {
        this.phoneNumberInput = this.user.TwoFactorPhoneNumber;
      }
      else if(this.user.PhoneNumber.length > 0) {
        this.phoneNumberInput = this.user.PhoneNumber;
      }
    }
    this.deliveryMethod = this.deliveryMethods[0];

  }

 decodeEntities = (function() {
    // this prevents any overhead from creating the object each time
    var element = document.createElement('div');
  
    function decodeHTMLEntities (str) {
      if(str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = '';
      }
  
      return str;
    }
  
    return decodeHTMLEntities;
  })();

  sendEmail() {
    this.deliveryMethod = "Email";
    this.sendCode();
  }

  sendCode() {
    let theWindow: any = window;
    this.errorText = "";
    if(this.deliveryMethod != 'Email' && (!this.phoneNumberInput || this.phoneNumberInput.length < 10)) {
      this.errorText = "Please enter a valid phone number.";
      return;
    }

    this.submitDisabled = true;
    let smsData = {
      Username: this.user.Username,
      Password: this.decodeEntities(theWindow.staticRange),
      PhoneNumber: this.deliveryMethod == 'Email' ? '' : this.phoneNumberInput,
      DeliveryMethod: this.deliveryMethod
    };
    this.phoneService.sendSmsCode(smsData).subscribe((result) => {
      console.log(result);
      this.pageState = 'code-sent';
      this.verifyCodeDisabled = false;
    }, (e) => {
      console.error(e);
      this.submitDisabled = false;
      alert("There was a problem sending the verification code. Please try again.");
    });

  }

  verifyCode() {
    let theWindow: any = window;
    this.errorText = "";

    if(!this.codeInput || this.codeInput.length < 6) {
      this.errorText = "Please enter a valid 6 digit code.";
      return;
    }

    let data = {
      Username: this.user.Username,
      Password: this.decodeEntities(theWindow.staticRange),
      Code: this.codeInput,
      RememberMe: this.rememberMe,
      ReturnUrl: this.returnUrl,
      DeliveryMethod: this.deliveryMethod,
      Remember2FA: this.remember2FA
    };
    this.verifyCodeDisabled = true;
    this.phoneService.verifySmsCode(data).subscribe((result) => {
      if(result == "SelectSubscriptionContext") {
        window.location.href = `/Account/SelectSubscriptionContext?returnUrl=${this.returnUrl}&isImpersonated=false`
      } else {
        let targetUrl = `/`;
        if(this.returnUrl.length > 0) {
          targetUrl = this.returnUrl;
        }
        window.location.href = targetUrl;
      }
    }, (e) => {
      console.error(e);
      this.verifyCodeDisabled = false;
      // The server puts user-facing copy in the response body (text/plain);
      // the reason phrase (statusText) is the legacy channel and is dropped
      // entirely by HTTP/2. Skip bodies that look like an IIS/ASP.NET HTML
      // error page rather than our copy.
      if(e && typeof e.error === 'string' && e.error.length > 0 && e.error.charAt(0) !== '<') {
        this.errorText = e.error;
        this.codeInput = '';
      } else if(e && e.statusText) {
        this.errorText = e.statusText;
        this.codeInput = '';
      } else {
        this.errorText = "There was a problem verifying your code.";
      }

    });
  }

  sendNewCode() {
    this.codeInput = '';
    this.verifyCodeDisabled = true;
    this.sendCode();
    this.newCodeSent = true;
  }

  goBack() {
    this.verifyCodeDisabled = false;
    this.codeInput = '';
    this.submitDisabled = false;
    this.pageState = 'enter-number';
    this.newCodeSent = false;
  }

}
